// @ts-nocheck
import {
  DatasetSource,
  GeoCoordinates,
  SavedPairCriteria,
  StudiesSearch,
  schGeoListingsFilters,
} from '@aloft/toolkit-shared';

import { useGetListingsByPolygon } from '../../../hooks/api/toolkitComponents.js';
import { runMatchSearch } from '../matching/runMatchSearch.js';
import { AdjustPairedSalesStandaloneModuleProps } from '../types.js';
import { getListingsByPolygon } from '../utils/getListingsByPolygon.ts';
import { listingsToToolkitProperties } from '../utils/listingsToToolkitProperties.js';
import { makePairsFromResult } from '../utils/makePairsFromResult.js';
import { savedCriteriaToWorkerInput } from '../utils/savedCriteriaToWorkerInput.js';

type GetPropertiesAndPairsParams = {
  coordinates: GeoCoordinates;
  search: StudiesSearch;
  pairCriteria: SavedPairCriteria;
};

export function useGetPropertiesAndPairs({
  getDisplayValue,
}: {
  getDisplayValue: AdjustPairedSalesStandaloneModuleProps['getDisplayValue'];
}) {
  const getListingsByPolygonReq = useGetListingsByPolygon();

  async function getPropertiesAndPairs({
    coordinates,
    search,
    pairCriteria,
  }: GetPropertiesAndPairsParams) {
    // TODO: Don't fetch listings if filters haven't changed
    const listings = await getListingsByPolygon({
      getListings: getListingsByPolygonReq,
      body: {
        coordinates: coordinates.map(([longitude, latitude]) => ({
          latitude,
          longitude,
        })),
        filters: schGeoListingsFilters.parse(search.filters),
      },
    });

    const properties = listingsToToolkitProperties({
      listings: listings.results,
      source: listings.source as DatasetSource,
    });

    const matchSearchInput = savedCriteriaToWorkerInput(pairCriteria);

    const matchSearch = runMatchSearch({
      dataset: properties,
      difference: matchSearchInput.differenceCriteria,
      match: matchSearchInput.matchCriteria,
      getPartitionKey: getDisplayValue,
      allowAnyMls: listings.source === 'abode',
    });

    const pairs = makePairsFromResult(matchSearch);

    return { properties, pairs };
  }

  return { getPropertiesAndPairs };
}
